import CircleLoader from './CircleLoader.vue';
import FullscreenLoader from './FullscreenLoader.vue';
import ProgressBar from './ProgressBar.vue';
import SectionLoader from './SectionLoader.vue';
import SpinnerLoader from './SpinnerLoader.vue';
import WidgetLoader from './WidgetLoader.vue';

export default [
  CircleLoader,
  FullscreenLoader,
  ProgressBar,
  SectionLoader,
  SpinnerLoader,
  WidgetLoader,
];
